import React from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
} from '@mui/material';

const ParEmpForm = ({ formik }) => {
  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 2,
          px: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={2}>
              <TextField
                variant="standard"
                required
                fullWidth
                id="employeeNm"
                name="employeeNm"
                label="담당자명"
                value={formik.values.employeeNm}
                onChange={formik.handleChange}
                error={
                  formik.touched.employeeNm && Boolean(formik.errors.employeeNm)
                }
                helperText={
                  formik.touched.employeeNm && formik.errors.employeeNm
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                variant="standard"
                fullWidth
                id="employeeGrade"
                name="employeeGrade"
                label="직급"
                value={formik.values.employeeGrade}
                onChange={formik.handleChange}
                error={
                  formik.touched.employeeGrade &&
                  Boolean(formik.errors.employeeGrade)
                }
                helperText={
                  formik.touched.employeeGrade && formik.errors.employeeGrade
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                variant="standard"
                fullWidth
                id="dutiesNm"
                name="dutiesNm"
                label="담당업무"
                value={formik.values.dutiesNm}
                onChange={formik.handleChange}
                error={
                  formik.touched.dutiesNm && Boolean(formik.errors.dutiesNm)
                }
                helperText={formik.touched.dutiesNm && formik.errors.dutiesNm}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                variant="standard"
                fullWidth
                required
                id="telNo"
                name="telNo"
                label="연락처"
                value={formik.values.telNo}
                onChange={formik.handleChange}
                error={formik.touched.telNo && Boolean(formik.errors.telNo)}
                helperText={formik.touched.telNo && formik.errors.telNo}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                variant="standard"
                fullWidth
                required
                id="emailAddr"
                name="emailAddr"
                label="이메일"
                value={formik.values.emailAddr}
                onChange={formik.handleChange}
                error={
                  formik.touched.emailAddr && Boolean(formik.errors.emailAddr)
                }
                helperText={formik.touched.emailAddr && formik.errors.emailAddr}
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={11}>
              <TextField
                fullWidth
                label="비고"
                variant="standard"
                name="employeeDesc"
                id="employeeDesc"
                value={formik.values.employeeDesc}
                onChange={formik.handleChange}
                error={
                  formik.touched.employeeDesc &&
                  Boolean(formik.errors.employeeDesc)
                }
                helperText={
                  formik.touched.employeeDesc && formik.errors.employeeDesc
                }
              />
            </Grid>
            <Grid item xs={1} textAlign="center">
              <Button color="primary" variant="outlined" type="submit">
                저장
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ParEmpForm;
